import { useState } from 'react';

import { MbscCalendarEvent } from '@mobiscroll/react';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';

import { dispatcherSlice } from '../dispatcher.slice';
import { toggleExpansionInDOM } from './DispatchCalendarAssignment/AssignmentHeader/AssignmentColumnExpandButton';

export function useAssignedTripSearchColumnExpansion() {
  const dispatch = useAppDispatch();

  const assignmentColumnVisualState = useAppSelector(
    (state) => state.dispatcher.assignmentColumnVisualState
  );

  const [expandedSearchAssignmentId, setExpandedSearchAssignmentId] = useState<
    string | null
  >(null);

  const handleColumnExpand = (e: MbscCalendarEvent) => {
    const assignmentId = e.event?.trip?.assignment_id;

    const isExpanded =
      assignmentColumnVisualState[assignmentId]?.isExpanded === true;

    if (!assignmentId) {
      return;
    }

    if (!isExpanded) {
      toggleExpansionInDOM(false, assignmentId);
      dispatch(
        dispatcherSlice.actions.toggleAssignmentColumnExpanded(assignmentId)
      );
      setExpandedSearchAssignmentId(assignmentId);
    }
  };

  const handleMaybeColumnCollapse = () => {
    if (expandedSearchAssignmentId) {
      toggleExpansionInDOM(true, expandedSearchAssignmentId);
      dispatch(
        dispatcherSlice.actions.toggleAssignmentColumnExpanded(
          expandedSearchAssignmentId
        )
      );
      setExpandedSearchAssignmentId(null);
    }
  };

  return {
    handleColumnExpand,
    handleMaybeColumnCollapse,
  };
}
